// extracted by mini-css-extract-plugin
export default {"CredentialBlock__titleWrap":"CredentialBlock_CredentialBlock__titleWrap__LM0ea","CredentialBlock__contentWrap":"CredentialBlock_CredentialBlock__contentWrap__gpDYU"};